import React from 'react';
import Modal from 'react-awesome-modal';
import {clearMultipleExistingMandates, deleteMultipleExistingMandates} from '../../../Services/IBS/IbsService';

export const ExistingMandateMultiActionModal = ({multiActionModalSettings, setMultiActionModalSettings, mandates}) => {
    return (<Modal
        width="1300"
        className="testClass"
        effect="fadeInDown"
        visible={multiActionModalSettings.show}
    >
        <div className="commentModal multipleModal" id="multipleModal">
            <h3><i className="fa fa-edit"></i> Confirm running multiple actions</h3>
            <hr/>
            <div className="tableContainer">
                <table className="NoAction">
                    <thead>
                    <tr>
                        <th style={{width: '8%'}}>Mandate ID</th>
                        <th style={{width: '8%'}}>AgrID</th>
                        <th style={{width: '18%'}}>NAV</th>
                        <th style={{width: '16%'}}>CostBps</th>
                        <th style={{width: '22%'}}>Manager</th>
                        <th style={{width: '22%'}}>Fund</th>
                        <th style={{width: '6%'}}>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {mandates?.length > 0 ? mandates.map(selectedRow => {
                        if (selectedRow.isSelected) {
                            return (<tr className="removeRow">
                                <td>{selectedRow.mandateId > 0 ? selectedRow.mandateId : 'NA'}</td>
                                <td>{selectedRow.agrId}</td>
                                <td>{selectedRow.holdingNavAvg}</td>
                                <td>{selectedRow.costBps}</td>
                                <td>{selectedRow.managerName}</td>
                                <td>{selectedRow.fundName}</td>
                                <td>{multiActionModalSettings.mode === 'clearValues' ? 'Clear Values' : 'Remove'}</td>
                            </tr>);
                        }
                    }) : null}
                    </tbody>
                </table>
            </div>
            <button type="button" className="btn btn-close green" onClick={() => {
                let selectedMandateIds = mandates
                    .filter(mandate => mandate.isSelected)
                    .map(mandate => mandate.mandateId);
                
                let promise = undefined;
                if(multiActionModalSettings.mode === "clearValues") {
                    promise = clearMultipleExistingMandates(selectedMandateIds);
                } else  if (multiActionModalSettings.mode === "remove") {
                    promise = deleteMultipleExistingMandates(selectedMandateIds);
                }
                
                if(promise) {
                    promise.then(() => {
                        setMultiActionModalSettings({show: false, mode: ''})
                    });
                }
            }}>
                Confirm
            </button>
            <button type="button" 
                    className="btn btn-close orange" 
                    onClick={() => setMultiActionModalSettings({show: false, mode: ''})}>Cancel</button>
        </div>
    </Modal>)
}